import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PrivateRoute } from "./privateRoutes";
import { AdminOnly } from '../components/AdminOnly';
import { Login } from '../pages/Login';
import { Home } from '../pages/Home';
import { Collaborator } from '../pages/Collaborator';
import { Reports } from '../pages/Reports';
import { Ambassadors } from '../pages/Ambassadors';
import { Broadcasts } from '../pages/Broadcasts';

export const Routers = () =>{
  return(
    <Routes>
      <Route path="/" element={<Login/>} />
      <Route path="/dashboard" element={
        <AdminOnly>
          <PrivateRoute/>
        </AdminOnly>
      }>
        <Route element={<Home/>} path="/dashboard"/>
      </Route>
      <Route path="/admins" element={
        <AdminOnly>
          <PrivateRoute/>
        </AdminOnly>
      }>
        <Route element={<Collaborator/>} path="/admins"/>
      </Route>
      <Route path="/ambassadors" element={
        <AdminOnly>
          <PrivateRoute/>
        </AdminOnly>
      }>
        <Route element={<Ambassadors/>} path="/ambassadors"/>
      </Route>
      <Route path="/broadcasts" element={
        <AdminOnly>
          <PrivateRoute/>
        </AdminOnly>
      }>
        <Route element={<Broadcasts/>} path="/broadcasts"/>
      </Route>
      <Route path="/reports" element={
        <AdminOnly>
          <PrivateRoute/>
        </AdminOnly>
      }>
        <Route element={<Reports/>} path="/reports"/>
      </Route>
    </Routes>
  )
}
